import Header from "components/Header/Header";
import HeaderLogged from "components/Header/HeaderLogged";
import { useLocation } from "react-router-dom";

const SiteHeader = () => {
  let location = useLocation();

  return location.pathname === "/home2" ? <Header /> : <HeaderLogged />;
};

export default SiteHeader;
